import React, { useState } from 'react'
import AccountIcon from '../../assets/icons/account-icon.svg'
import PasswordIcon from '../../assets/icons/password-icon.svg'
import { Input, LoaderCircular as Loader } from '../common'
import { observer } from 'mobx-react-lite'
import { AuthStore } from '../../store/'
import { Link, useHistory } from 'react-router-dom'
import { useText, useLang } from '../../texts'

const SignIn = observer(() => {
  const router = useHistory()
  const { lang, defaultLang } = useLang()
  const pathEnd = defaultLang === lang ? '' : '?lang=' + lang

  const t = useText()
  const [errors, setErrors] = useState({ email: '', password: '' })
  const handleSingIn = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const email = formData.get('email')
    const password = formData.get('password')
    let errors = { email: '', password: '' }

    // Validate
    if (!email) {
      errors.email = t('login-required')
    }
    if (!password) {
      errors.password = t('password-required')
    }
    // Sing In or show Errors
    if (email && password) {
      AuthStore.signIn(email, password)
        .then(() => {
          router.push('/' + pathEnd)
        })
        .catch((err) => {
          setErrors({ email: t('error-user-not-found') })
        })
    } else {
      setErrors(errors)
    }
  }
  const isFetch = AuthStore.isFetch
  return (
    <form onSubmit={handleSingIn} className="card">
      <Loader show={isFetch} />
      {/* <Loader show={isFetch} isBackground /> */}
      <h3 className="card__title">{t('sign-in')}</h3>

      <Input
        icon={AccountIcon}
        name="email"
        error={errors.email}
        placeholder={t('login-placeholder')}
      />
      <Input
        icon={PasswordIcon}
        name="password"
        type="password"
        error={errors.password}
        placeholder={t('password-placeholder')}
      />

      <div className="card-actions">
        <button className="btn btn-primary ml-auto">{t('next')}</button>
      </div>

      <div className="card-bottom-link">
        <Link className="link" to="/forget-password">
          {t('forgot-password-q')}
        </Link>
      </div>
    </form>
  )
})

export default SignIn
